import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from "react-redux";
import { productCategoryFetch, setSubStage } from '../../../../slices/eligibility/eligibilitySlice';
import NoImageComponent from '../../../common/NoImage';
import { toTitleCaseAdvanced } from '../../../../utils/functions';
import ImageComponent from '../../../common/Image';
import { toast } from 'react-toastify';
import Loader from '../../../common/Loader';

function Category({ setData, data: currentData }) {
    const dispatch = useDispatch();
    const { subStage, stage } = useSelector(state => state.eligibility)
    const href = "#"
    const [searchPopup, setSearchPopup] = useState(false)
    const [searchTerm, setSearchTerm] = useState('');
    const [loader, setLoader] = useState(false);

    const urlParams = new URLSearchParams(window.location.search);
    const referenceId = urlParams.get('referenceId');
    const { dealerCode } = useSelector(state => state.dashboard)

    const productData = useSelector(state => state?.eligibility?.categoryData);

    useEffect(() => {
        let isMounted = true;


        const fetchProductData = async () => {
            if (stage === 'product' && (subStage === 'category') &&
                referenceId &&
                dealerCode) {
                let dealer_Code = dealerCode?.split('-')[0]?.trim();
                if (isMounted) setLoader(true);
                try {
                    const response = await dispatch(productCategoryFetch({
                        "reference_id": referenceId,
                        "dealer_code": dealer_Code,
                        "type": "category",
                        ...currentData?.brand

                    })).unwrap();

                    setLoader(false);

                    if (isMounted && response?.response_code !== 'S100') {
                        !response?.payload?.error &&
                        toast.error(response?.response_string);
                    }
                } catch (error) {
                    setLoader(false); // Always set loader to false
                    if (isMounted) {
                        toast.error('An error occurred while fetching product data');
                    }
                }

            }
        };

        fetchProductData();

        return () => {
            isMounted = false;
        };
    }, [stage, subStage, referenceId, dealerCode]);

    const setProduct = (product) => {
        if (setData) {
            setData(prev => ({
                ...prev,
                product: { ...product }
            }));
        }
        dispatch(setSubStage("variant"));
    };

    const getCategoryImageInfo = (categoryName) => {
        const name = categoryName?.toLowerCase();

        switch (name) {
            case 'mobile phone':
                return { src: 'mobilephn.png', isSpecificBrand: true };
            case 'air cooler':
                return { src: 'Ac.svg', isSpecificBrand: true };
            case 'deep freezer':
                return { src: 'fridge.svg', isSpecificBrand: true };
            case 'air conditioner':
                return { src: 'Ac.svg', isSpecificBrand: true };
            case 'refrigerator':
                return { src: 'fridge.svg', isSpecificBrand: true };
            case 'washing machine':
                return { src: 'washingmech.svg', isSpecificBrand: true };
            case 'led tv':
                return { src: 'television.svg', isSpecificBrand: true };
            default:
                return { src: 'no2.svg', isSpecificBrand: false };
        }
    };

    const filteredCategory = Array.isArray(productData)
        ? productData.filter(item =>
            item?.category?.toLowerCase().includes(searchTerm.toLowerCase())
        )
        : [];


    return (
        <>
            {loader === true &&
                <>
                    <Loader />
                </>}
            <div className="col-md-9 col-sm-12 Side-bank-Right variant-div">
                <div className="col-12 mb-1 static-tab">
                    <div className="d-flex align-items-center justify-content-between">
                        <div className="d-flex gap-2 align-items-center">
                            <p className="Pname-i mb-0">
                            </p>
                            <div
                                className="lh-0"
                                role="button"
                                tabIndex={0}
                                onClick={() => dispatch(setSubStage("brand"))}
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter' || e.key === ' ') {
                                        e.preventDefault();
                                        dispatch(setSubStage("brand"));
                                    }
                                }}
                            >
                                <p className="text-decoration-none grey small mb-0">Brand</p>
                                <p className="small mb-0 fw-600">{toTitleCaseAdvanced(currentData?.brand?.brand_name || '')}</p>
                            </div>
                            <span className="icon-arrowright-L1 blue"></span>
                            <div className="lh-0">
                                <a href={href} className="text-decoration-none blue fs-14">Select Category</a>
                            </div>
                        </div>
                        <div className="fs-3">
                            <span className="icon-searchnormal inside-search border p-1 rounded text-secondary  border-secondary fs-6"
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter' || e.key === ' ') {
                                        e.preventDefault()
                                        setSearchPopup(true)
                                    }
                                }}
                                onClick={() => {
                                    setSearchPopup(true)
                                }}></span>
                        </div>
                    </div>
                </div>
                <div className="row gy-4 mt-2">
                    {/* Only show categories or 'No category found' after loader is false */}
                    {loader ? null : (
                        Array.isArray(productData) && productData.length > 0 ? (
                            productData.map((item) => {
                                const categoryImageInfo = getCategoryImageInfo(item?.category);

                                return (
                                    <div
                                        key={item?.category}
                                        className="col-6 col-lg-3 col-md-4"
                                        role="button"
                                        tabIndex="0"
                                        onClick={() => setProduct(item)}
                                        onKeyDown={(e) => {
                                            if (e.key === 'Enter' || e.key === ' ') {
                                                setProduct(item);
                                            }
                                        }}
                                    >
                                        <div className="product-details">
                                            <div className="text-center">
                                                {item?.category_image_url ? (
                                                    <img loading="lazy"
                                                        src={item.category_image_url}
                                                        className="img-fluid"
                                                        alt={item.category || "Category"}
                                                        height="120px"
                                                        width="120px"
                                                    />
                                                ) : categoryImageInfo.isSpecificBrand ? (
                                                    <ImageComponent
                                                        fileName={categoryImageInfo.src}
                                                        className="img-fluid"
                                                        height="150px"
                                                        width="150px"
                                                        alt={item?.category || 'Category'}
                                                    />
                                                ) : (
                                                    <NoImageComponent
                                                        fileName="no2.svg"
                                                        className="img-fluid"
                                                        height="150px"
                                                        width="150px"
                                                        alt={item?.category || 'Category'}
                                                    />
                                                )}
                                            </div>
                                            <div className="dash-view-catagory text-center">
                                                <p className="fw-semibold">{toTitleCaseAdvanced(item?.category)}</p>
                                            </div>
                                        </div>
                                    </div>
                                )
                            })
                        ) : (
                            <h6 className="text-center">No category found</h6>
                        )
                    )}
                </div>
                {searchPopup &&
                    <>
                        <div
                            className="modal show fade"
                            id="searchrole"
                            style={{ display: "block" }}
                            aria-hidden="true"
                            aria-labelledby="Dealerrole"
                            tabindex="-1"
                            onClick={() => setSearchPopup(false)}
                        >
                            <div className="modal-dialog bottom-modal">
                                <div className="modal-content blue" onClick={(e) => e.stopPropagation()}
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter' || e.key === ' ') {
                                            e.stopPropagation();
                                        }
                                    }}>
                                    <div className="modal-header">
                                        <div className="top-draw"></div>
                                    </div>
                                    <div
                                        className="d-flex align-items-center justify-content-between px-3 "
                                    >
                                        <h6 className="mb-1">Category Search</h6>

                                    </div>
                                    <div className="modal-body searchrole p-4" style={{ maxHeight: '60vh', overflowY: 'auto' }}>
                                        <form
                                            className="col-12 col-lg-auto mb-3 mb-lg-0 me-lg-3 position-relative"
                                            role="search"
                                            onSubmit={(e) => e.preventDefault()}
                                        >
                                            <input
                                                type="search"
                                                className="form-control input-underline"
                                                placeholder="Search by Category"
                                                aria-label="Search"
                                                value={searchTerm}
                                                onChange={(e) => setSearchTerm(e.target.value)}
                                            />
                                            <div className="has-i-search hidden-search-box">
                                                <span className="icon-searchnormal fs-4 inside-search border-0"></span>
                                            </div>
                                        </form>

                                        <div className="row mb-3 mt-3">
                                            <div className="col-md-12 RightPane">
                                                <p className="text-secondary mb-2">Search Results</p>
                                            </div>

                                            {filteredCategory?.length > 0 ? (
                                                filteredCategory?.map((item) => {
                                                    return (
                                                        <div
                                                            key={item?.category}
                                                            className="col-md-12 mt-2"
                                                            role="button"
                                                            tabIndex={0}
                                                            onClick={() => {
                                                                setProduct(item);
                                                                setSearchPopup(false); // optional: close modal after select
                                                            }}
                                                            onKeyDown={(e) => {
                                                                if (e.key === 'Enter' || e.key === ' ') {
                                                                    e.preventDefault();
                                                                    setProduct(item);
                                                                    setSearchPopup(false);
                                                                }
                                                            }}
                                                        >
                                                            <div className="d-flex align-items-center gap-2">
                                                                <span className="fw-semibold">{toTitleCaseAdvanced(item?.category)}</span>
                                                            </div>
                                                        </div>
                                                    );
                                                })
                                            ) : (
                                                <div className="col-md-12 mt-2">
                                                    <p className="text-muted">No matching Category</p>
                                                </div>
                                            )}
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                        <div className="modal-backdrop fade show"></div>
                    </>
                }
            </div>
        </>
    );
}

// ✅ Add PropTypes to satisfy ESLint/SonarLint
Category.propTypes = {
    setData: PropTypes.func.isRequired
};

export default Category;
